@if (label()) {
    <span
        class="sir-rating-item__label sir-text-style-paragraph-s-bold sir-text-style-color-secondary"
        aria-hidden="true"
        >{{ label() }}</span
    >
}

<span
    class="sir-rating-item__dots"
    role="meter"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-valuenow]="clampedValue()"
    aria-valuemin="0"
    [attr.aria-valuemax]="clampedMax()"
>
    @for (filled of dots(); track $index) {
        <span class="sir-rating-item__dot" [class.is-filled]="filled"></span>
    }
</span>
